/**
 * A vehicle row read back from `GET /vehicles/:vin` is NOT the wizard's vehicle
 * object. Its identity columns are PascalCase — `Vehicle_ID`, `Year`, `Make`,
 * `Model`, `Trim`, `VIN` — while `body`, `size`, `id_car_trim` and the marine
 * fields are lowercase. Every consumer in the client (the catalog readiness
 * gate, `catalogFilterParams`, `isMarineAsset(vehicle.vin)`, the edit-job
 * header) reads the wizard's lowercase names, so an un-normalised row reads as
 * having no id, no year, no VIN: the catalog gate rejected it and the edit
 * screen's services step stayed empty (request 8634, 2026-09-11), and a boat's
 * `VIN` would not even be recognised as marine.
 *
 * Normalise ONCE at the read boundary. Lowercase keys already present are never
 * overwritten; the PascalCase originals are kept so nothing that reads them
 * breaks.
 *
 * ZERO IMPORTS BY DESIGN — unit-tested by `scripts/test/storedVehicle.test.mjs`.
 */
const ALIASES = [
  ['id', ['Vehicle_ID', 'vehicle_id', 'ID']],
  ['vin', ['VIN', 'Vin', 'vehicle_vin']],
  ['year', ['Year']],
  ['make', ['Make']],
  ['model', ['Model']],
  ['trim', ['Trim']],
  ['body', ['Body']],
  ['size', ['Size', 'id_car_type']],
];

const present = (v) => v !== undefined && v !== null && v !== '';

export function normalizeStoredVehicle(row) {
  if (!row || typeof row !== 'object') return row;
  const out = { ...row };
  for (const [key, sources] of ALIASES) {
    if (present(out[key])) continue;
    const src = sources.find((s) => present(row[s]));
    if (src) out[key] = row[src];
  }
  return out;
}

const storedVehicle = { normalizeStoredVehicle };
export default storedVehicle;
